import { connect } from 'react-redux';
import Figures from './figures';

function mapStateToProps(state) {
  const {
    figures: {
      data = [],
    },
  } = state;

  return {
    figures: data,
  };
}

export default connect(mapStateToProps)(Figures);
